// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"882736f1","353":"d8c51536","604":"233b6614","761":"2b5d9cdf"}[chunkId] + ".chunk.css";
};